/*
Carl Flint
*/

// import pageController from './page.js';
import HomeController from './home.js';
import CvController from './cv.js';
import MapController from './map.js';

export {
  // pageController,
  HomeController,
  CvController,
  MapController
};



// WEBPACK FOOTER //
// src/js/controller/index.js